<script setup>
import ServiceAttachmentGrid from '@/components/registry/ServiceAttachmentGrid.vue'

</script>
<template>
  <service-attachment-grid />
</template>
